import styled from "styled-components";
import {dialogHighlightedTextMixin} from "../../../../modal-dialog/boxes/text/dialog-text.box";

export const AmountSpan = styled.span`
    ${dialogHighlightedTextMixin}
`
